<ng-container>
	<mat-card [ngStyle]="_visible()" class="panel">

		<div *ngIf="!locked" [ngClass]="{'active-panel-tab': _active(), 'panel-tab': !_active()}" fxLayout="row">
			<div fxFlex="fit-content" fxLayoutAlign="start">
				<button (click)="_visibleChange(false);" *ngIf="!locked" class="close-button" color="primary" mat-icon-button id="mat-close-button">
					<mat-icon class="close-icon">clear</mat-icon>
				</button>
			</div>
			<div class="panel-title" fxFlex="">{{title}}</div>
		</div>

		<mat-card-content class="panel-content" style="padding:0;">
			<div *ngIf="locked"></div>
			<mat-card>
				<mat-card-content>
					<canvas #traj></canvas>
				</mat-card-content>
			</mat-card>
		</mat-card-content>
	</mat-card>
</ng-container>
